import { usePatientContextStore } from '@/stores/patientContext';

/**
 * Which chart the vitals cache belongs to (ndsUElC6).
 *
 * The cache is `login.phrData.measures` / `measCcdMeasIds`, filled by
 * `login/addMeasures` from `/data/externalMeasures`. Main never needed a key
 * on it: its chart entry (enterPatientChartAndRefresh) replaced the whole
 * model with the new chart's getAllData, measures included. The port keeps
 * `phrData` across a chart switch - the chart is the patient context's, and
 * opening one from the patient list neither reloads nor refetches the model -
 * so the cache records whose readings it holds (`phrData.measuresPatientId`),
 * and `login/getAllData`, `login/addMeasures` and
 * `login/watch/areExternalMeasuresLoaded` hold it to the chart in view.
 */

/** A chart id as the vitals cache keys it: a string, or null for no chart. */
export function chartKey(patientId) {
  return patientId === null || patientId === undefined || patientId === '' ? null : String(patientId);
}

/**
 * The chart whose readings the cache holds, or `undefined` when `addMeasures`
 * has not filled it.
 *
 * `in`, not `hasOwnProperty.call`: Vue's reactive proxy tracks the `in`
 * operator, so a getter built on this re-evaluates when `addMeasures` first
 * adds the key; `hasOwnProperty.call` is not tracked and left
 * `areExternalMeasuresLoaded` cached at false.
 */
export function measuresChart(phrData) {
  return phrData && typeof phrData === 'object' && 'measuresPatientId' in phrData
    ? phrData.measuresPatientId
    : undefined;
}

/** The chart in view, keyed as the cache keys it. */
export function chartInView() {
  return chartKey(usePatientContextStore().patientId);
}
